import { DropDownButton, DropdownItem, Icon, IconName, Stack, Typography } from '@optimus-web/core';
import { lt, showSuccessAlert } from '@mews/framework';
import { useDeleteConfirmationDialog } from '@mews-commander/ui';
import { useRepositoryMutation } from '@mews-commander/data-access';
import { WithOwnerId } from '@mews-commander/types';

type Props = {
    id: string;
    propertyName: string;
    portfolioName: string;
} & WithOwnerId;

export const RowActionMenu = ({ id, propertyName, portfolioName, ownerId }: Props) => {
    const { mutateAsync, isPending } = useRepositoryMutation('enterpriseRelationships', 'delete', {
        invalidateQueries: { enterpriseRelationships: ['getOverviewEntries'] },
        onSuccess: () =>
            showSuccessAlert({
                description: lt('RemovePropertySuccessMessage', { property: propertyName }),
            }),
    });

    const { confirmationDialog, openConfirmationDialog } = useDeleteConfirmationDialog({
        deleteAction: async () => mutateAsync({ id, enterpriseId: ownerId }),
        renderContent: () => (
            <Typography textStyle="bodyMedium" as="div">
                {lt('RemovePropertyHint')}
            </Typography>
        ),
        title: lt('RemovePropertyTitle', { property: propertyName, portfolio: portfolioName }),
        loading: isPending,
    });

    return (
        <>
            <DropDownButton icon={IconName.More} size="small" variant="ghost">
                <DropdownItem
                    label={
                        <Stack spacing="100" alignment="center">
                            <Icon value={IconName.CancelSquare} />
                            {lt('Remove')}
                        </Stack>
                    }
                    onClick={openConfirmationDialog}
                />
            </DropDownButton>
            {confirmationDialog}
        </>
    );
};
